import { createAction, props } from '@ngrx/store';

export const loadQuickbooks = createAction(
  '[Quickbooks] Load Quickbooks'
);

export const loadQuickbooksSuccess = createAction(
  '[Quickbooks] Load Quickbooks Success',
  props<{ data: any }>()
);

export const loadQuickbooksFailure = createAction(
  '[Quickbooks] Load Quickbooks Failure',
  props<{ error: any }>()
);

export const loadMostRecent = createAction(
  '[Quickbooks] Load Most Recent'
);

export const loadMostRecentSuccess = createAction(
  '[Quickbooks] Load Most Recent Success',
  props<{ data: any }>()
);

export const loadMostRecentFailure = createAction(
  '[Quickbooks] Load Most Recent Failure',
  props<{ error: any }>()
);

export const loadSyncs = createAction(
  '[Quickbooks] Load Syncs'
);

export const loadSyncsSuccess = createAction(
  '[Quickbooks] Load Syncs Success',
  props<{ payload: any }>()
);

export const loadSyncsFailure = createAction(
  '[Quickbooks] Load Syncs Failure',
  props<{ error: any }>()
);

export const addSync = createAction(
  '[Quickbooks] Add Sync',
  props<{ sync: any }>()
);